import React from 'react';
import PropTypes from 'prop-types';
import ContactFormStyles from './contact_form_styles';
import {
  Field, reduxForm, TextField, FieldTheme, MuiThemeProvider,
} from '../../../common/form/form';

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

const defaultProps = {
  // prop: 'ContactForm View',
};

const ContactForm = ({
  // eslint-disable-next-line react/prop-types
  handleSubmit, status, errorMessage,
}) => (
  <ContactFormStyles>
    { status === 'success' ? (
      <div className="status">
        Thank you for your reservation!
      </div>
    ) : (
      <MuiThemeProvider theme={FieldTheme}>
        <form id="reserve-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-6">
              <h3>How can we reach you?</h3>
              <div className="row">
                <div className="col-xs-6">
                  <Field component={TextField} label="First Name" name="firstname" fullWidth />
                </div>
                <div className="col-xs-6">
                  <Field component={TextField} label="Last Name" name="lastname" fullWidth />
                </div>
              </div>
              <Field component={TextField} label="Email Address" name="email" type="email" fullWidth required />
            </div>
            <div className="col-sm-6">
              <h3>How many utensils?</h3>
              <div className="row">
                <div className="col-xs-4">
                  <Field component={TextField} type="number" label="Forks" name="fork_quantity" fullWidth />
                </div>
                <div className="col-xs-4">
                  <Field component={TextField} type="number" label="Knives" name="knife_quantity" fullWidth />
                </div>
                <div className="col-xs-4">
                  <Field component={TextField} type="number" label="Spoons" name="spoon_quantity" fullWidth />
                </div>
              </div>
            </div>
          </div>
          { status === 'failed' && (
            <div className="flash error">{ errorMessage }</div>
          )}
          { status === 'submitting' ? (
            <div className="flash">Reserving...</div>
          ) : (
            <input id="reserve-form-submit" type="submit" className="btn primary" style={{ width: '100%' }} value="Reserve" />
          )}
        </form>
      </MuiThemeProvider>
    )}
  </ContactFormStyles>
);

ContactForm.propTypes = propTypes;
ContactForm.defaultProps = defaultProps;

const ContactFormView = reduxForm({ form: 'ContactForm', enableReinitialize: true })(ContactForm);

export default ContactFormView;



// WEBPACK FOOTER //
// ./src/hub_spot_form/components/contact_form/contact_form_view.js